var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.675 9.44l3.75 3.95a.73.73 0 0 1 0 1.004.657.657 0 0 1-.953 0l-3.863-4.07a5.6 5.6 0 1 1 1.066-.884zM8.56 8.56a4.186 4.186 0 1 0-5.92-5.92 4.186 4.186 0 0 0 5.92 5.92z","fill":"#424242","fillRule":"evenodd"}));
}

Search.defaultProps = {"width":"14","height":"15","viewBox":"0 0 14 15"};

module.exports = Search;

Search.default = Search;
